export default "__VITE_ASSET__Da0tXRge__"